// Same-origin defaults — the SPA + API are served from one domain via nginx,
// so the only correct API base is window.location.origin + '/api'. The old
// hardcoded `https://hrgptai.in/*` fallbacks have been removed so a misconfigured
// .env can never silently send prod traffic to the wrong host.
const origin = typeof window !== 'undefined' ? window.location.origin : '';

const config = {
  aiApiUrl: process.env.REACT_APP_AI_URL  || `${origin}/api`,
  apiUrl:   process.env.REACT_APP_API_URL || `${origin}/api`,
  baseUrl:  origin || process.env.REACT_APP_BASE_URL || '',
};

export default config;
